/**
 * Logger Utility
 * Provides console logging with timestamp for debugging purposes
 */

class Logger {
    private static createTimestamp(): string {
        return new Date().toISOString().replace("T", " ").substring(0, 23);
    }

    private static isLoggableObject(value: object): boolean {
        return value !== null;
    }

    public static log(...args: Array<string | number | boolean | null | undefined | object>): void {
        console.log(`[${this.createTimestamp()}]`, ...args);
    }

    public static error(...args: Array<string | number | boolean | null | undefined | object>): void {
        console.error(`[${this.createTimestamp()}]`, ...args);
    }

    public static warn(...args: Array<string | number | boolean | null | undefined | object>): void {
        console.warn(`[${this.createTimestamp()}]`, ...args);
    }

    public static debug(...args: Array<string | number | boolean | null | undefined | object>): void {
        const isDev =
            typeof import.meta !== "undefined" &&
            typeof import.meta.env !== "undefined" &&
            (import.meta.env.DEV === true || import.meta.env.MODE === "development");

        if (isDev) {
            console.debug(`[${this.createTimestamp()}]`, ...args);
        }
    }

    public static info(...args: Array<string | number | boolean | null | undefined | object>): void {
        this.log(...args);
    }
}

export { Logger };
